export default __webpack_public_path__ + "ff3d5023946f0ad2d981502f26e16864.png";